import styles from './auth-verify-render.module.scss';

export function AuthVerifyRender() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.loaderWrapper}>
          <div className={styles.loaderCircle}></div>
          <img src={'/favicon.ico'} alt={'KORE'} />
        </div>
        <span className={styles.title}>Authenticating...</span>
        <p className={styles.subtitle}>Verifying credentials with KORE</p>
      </div>
    </div>
  );
}
